import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Moon, Sun } from 'lucide-react';

import { Button } from '@repo/lib-design-system/primitives/button.component';
import { cn } from '@repo/lib-design-system/utils/tw-merge.util';

import { useTheme } from '@/shared/components/theme/theme.hook';

function isDarkTheme(theme: string): boolean {
  if (theme === 'system') {
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  }

  return theme === 'dark';
}

export function ThemeToggle(): ReactElement {
  const { t } = useTranslation();
  const { theme, setTheme } = useTheme();
  const isDark = isDarkTheme(theme);

  return (
    <Button
      aria-label={t('header.theme.toggle')}
      size="icon"
      variant="ghost"
      onClick={() => setTheme(isDark ? 'light' : 'dark')}
      className={cn(
        'size-8 rounded-md p-1.5 text-charcoal-800',
        'hover:bg-grey-100',
        'dark:text-white',
        'dark:hover:bg-white/10'
      )}
    >
      {isDark ? <Moon className="size-5" /> : <Sun className="size-5" />}
    </Button>
  );
}
